'use strict';

/**
 * BD.QuantityCounter: Manages quantity counters and handles +/- button clicks and cart updates
 */
var BD = window.BD = window.BD || {};
BD.QuantityCounter = (function($) {
  var lastActionTstamp = 0;
  var $counters;
  
  function setCartQuantity(variantId, quantity) {
    lastActionTstamp = Date.now();
    $counters.filter('[data-variant-id=' + variantId + ']').data('quantity', quantity);
    syncCartAndCounters();
  }
  
  function decrement($counter) {
    $counter = ($counter instanceof $) ? $counter : $(this).closest('.quantityCounter');
    
    var variantId = $counter.data('variant-id');
    var desiredQuantity = Math.max(0, parseInt($counter.data('quantity') || 0) - 1);

    setCartQuantity(variantId, desiredQuantity);
  }
  
  function increment($counter) {
    $counter = ($counter instanceof $) ? $counter : $(this).closest('.quantityCounter');

    var variantId = $counter.data('variant-id');
    var desiredQuantity = parseInt($counter.data('quantity') || 0) + 1;
    var maxQuantity = $counter.data('max-quantity');
    
    if (maxQuantity && maxQuantity < desiredQuantity) {
      desiredQuantity = maxQuantity;
    }
    
    setCartQuantity(variantId, desiredQuantity);
  }
  
  function setCounterQuantity($counter, quantity) {
    $counter.data('quantity', quantity);
    $counter.find('.quantityCounter__quantity').text(quantity);
    
    var incDisabled = ($counter.data('max-quantity') && quantity >= $counter.data('max-quantity')); 
    var decDisabled = (quantity == 0);
    $counter.find('.quantityCounter__incrementer').prop('disabled', incDisabled);
    $counter.find('.quantityCounter__decrementer').prop('disabled', decDisabled);
  }
  
  function setCountersFromCart() {
    var quantitiesByVariantId = {};
    
    CartJS.cart.items.forEach((item) => { 
      quantitiesByVariantId[item.variant_id] = item.quantity;
    });

    $counters.each((idx, el) => {
      var $counter = $(el);
      var variantId = $counter.data('variant-id');
      var quantity = (quantitiesByVariantId[variantId] || 0);
      setCounterQuantity($counter, quantity);
    }); 
  }
  
  function syncCartAndCounters(e) {
    /* If something goes wrong, we could end up sending hundreds of requests to 
     * Shopify as we attempt to correct an uncorrectable quantity.  So if there
     * were no user actions in the last 5 seconds and we're still trying to sync, 
     * just give up whatever we're doing and reset the counters to the current cart status. */
    if ((Date.now() - lastActionTstamp) > 5000) {
      setCountersFromCart();
      return;
    }
    
    var lineNumber = 1;
    var quantitiesByVariantId = {};
    var lineNumbersByVariantId = {};
    CartJS.cart.items.forEach((item) => { 
      quantitiesByVariantId[item.variant_id] = item.quantity;
      lineNumbersByVariantId[item.variant_id] = lineNumber++;
    });

    var updatesByVariantId = new Map();

    $counters.each(function() {
      var $counter = $(this);
      var variantId = $counter.data('variant-id');
      var cartQuantity = (quantitiesByVariantId[variantId] || '0');
      var counterQuantity = $counter.data('quantity');

      if (counterQuantity === undefined) {
        counterQuantity = cartQuantity;
      }
      else if (counterQuantity != cartQuantity) {
        updatesByVariantId.set(variantId, counterQuantity);
      }
      
      setCounterQuantity($counter, counterQuantity);
    });

    /* Add and Remove operations cannot be batched and must be done one at a time.  This is because
     * quantity updates refer to line numbers, and add/remove operations can change the line numbers,
     * which can cause updates to happen on the wrong lines.
     * 
     * So we allow a single add/remove operation, then we wait for the response from Shopify, which
     * will trigger this function again.
     */
    
    var dontBatch = false;
    
    updatesByVariantId.forEach((quantity, variantId) => {
      if (dontBatch) { return; }
      var isAddOp = !lineNumbersByVariantId[variantId];
      var isRemoveOp = !quantity;
      
      if (!isAddOp && !isRemoveOp) { return; }
      dontBatch = true;
      
      if (isAddOp) {
        CartJS.addItem(variantId, quantity);
      }
      else {
        CartJS.updateItem(lineNumbersByVariantId[variantId], 0);
      }
    });
    
    if (dontBatch) { return; }

    updatesByVariantId.forEach((quantity, variantId) => {
      CartJS.updateItem(lineNumbersByVariantId[variantId], quantity);
    });    
  }
  
  function init() {
    $counters = $('.quantityCounter');
    if (!$counters.length) { return; }

    $counters.find('.quantityCounter__decrementer').on('click', decrement);
    $counters.find('.quantityCounter__incrementer').on('click', increment);

    setCountersFromCart();
    $(document).on('cart.requestComplete', syncCartAndCounters);
  }

  $(document).on('cart.ready', init);
})(jQuery);  